import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WorkScope } from "./types";
import { v4 as uuidv4 } from 'uuid'

@Component({
  selector: 'app-add-scope-dialog',
  templateUrl: './add-scope-dialog.component.html'
})
export class AddScopeDialogComponent {
  form = new FormGroup({
    title: new FormControl<string>(null, [Validators.required]),
    option_name: new FormControl<string>(null, [Validators.required]),
    option_description: new FormControl<string>(null, [Validators.required])
  })

  constructor(
    private dialogRef: MatDialogRef<AddScopeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {reportTypeId: number}
  ) {}

  onSave() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(controlName => {
        if (this.form.controls[controlName].invalid) {
          console.log(controlName)
          this.form.controls[controlName].markAsTouched()
        }
      })
      return;
    }
    const optionId = uuidv4()
    const scope: WorkScope = {
      id: uuidv4(),
      isSystem: false,
      name: this.form.controls.title.value,
      options: [{
        id: optionId,
        isSystem: false,
        defaultName: this.form.controls.option_name.value,
        defaultDescription: this.form.controls.option_description.value,
        name: this.form.controls.option_name.value,
        description: this.form.controls.option_description.value
      }],
      selectedOptionId: optionId,
      reportTypeId: this.data.reportTypeId
    }

    this.dialogRef.close(scope)
  }

  onClose() {
    this.dialogRef.close()
  }
}